// Firestore collection names
export const COLLECTION_ADMINS = 'admins';
export const COLLECTION_COORDINATORS = 'coordinators';
export const COLLECTION_DOCTORS = 'doctors';
export const COLLECTION_GUILDS = 'guilds';
export const COLLECTION_REFERRALS = 'referrals';
export const COLLECTION_EVENTS = 'events';
export const COLLECTION_TESTIMONIALS = 'testimonials';
export const COLLECTION_DOCUMENTS = 'documents';
export const COLLECTION_DEPARTMENTS = 'departments';
export const COLLECTION_SPECIALTIES = 'specialties';

// Referral status values - ONLY these are allowed
export const STATUS_PENDING = 'pending';
export const STATUS_ACCEPTED = 'accepted';
export const STATUS_REJECTED = 'rejected';
export const STATUS_RESCHEDULED = 'rescheduled';
export const STATUS_CANCELLED = 'cancelled';
export const STATUS_COMPLETED = 'completed';

// Valid referral statuses list
export const VALID_REFERRAL_STATUSES = [
    STATUS_PENDING,
    STATUS_ACCEPTED,
    STATUS_REJECTED,
    STATUS_RESCHEDULED,
    STATUS_CANCELLED,
    STATUS_COMPLETED,
];

// Source system metadata
export const SOURCE_SYSTEM = 'guild_lite_v1';
export const SCHEMA_VERSION = 1;
export const COLLECTION_NOTIFICATIONS = 'notifications';

// Event types
export const EVENT_TYPE_CME = 'CME';
export const EVENT_TYPE_WEBINAR = 'Webinar';
export const EVENT_TYPE_MEET = 'Meet';
export const EVENT_TYPE_TRAINING = 'Training';

export const EVENT_TYPES = [
    EVENT_TYPE_CME,
    EVENT_TYPE_WEBINAR,
    EVENT_TYPE_MEET,
    EVENT_TYPE_TRAINING,
];

// Event modes
export const EVENT_MODE_ONLINE = 'Online';
export const EVENT_MODE_OFFLINE = 'Offline';

export const EVENT_MODES = [
    EVENT_MODE_ONLINE,
    EVENT_MODE_OFFLINE,
];

// Event statuses
export const EVENT_STATUS_DRAFT = 'Draft';
export const EVENT_STATUS_PUBLISHED = 'Published';

export const EVENT_STATUSES = [
    EVENT_STATUS_DRAFT,
    EVENT_STATUS_PUBLISHED,
];

// Testimonial statuses
export const TESTIMONIAL_STATUS_ACTIVE = 'active';
export const TESTIMONIAL_STATUS_HIDDEN = 'hidden';


// Medical specialties
export const MEDICAL_SPECIALTIES = [
    'General Practice',
    'Cardiology',
    'Dermatology',
    'Endocrinology',
    'Gastroenterology',
    'Neurology',
    'Oncology',
    'Ophthalmology',
    'Orthopedics',
    'Pediatrics',
    'Psychiatry',
    'Radiology',
    'Surgery',
    'Urology',
    'Other',
];

// Get status color
export function getStatusColor(status) {
    switch (status.toLowerCase()) {
        case 'pending':
            return '#FF9800';
        case 'accepted':
            return '#4CAF50';
        case 'rejected':
            return '#F44336';
        case 'rescheduled':
            return '#2196F3';
        case 'cancelled':
            return '#9E9E9E';
        case 'completed':
            return '#009688';
        default:
            return '#757575';
    }
}
